import { FormikErrors } from 'formik'
import { useModalControl } from '../../hooks/useModalControl'
import { CreateProductValues } from '../../redux-toolkits/products/products.type'
import { CategoryCard } from '../cards/categoryCard'
import { EditInput } from '../inputs/editInput'
import { SelectCategoriesModal } from '../modal/app_modals/selectCategoriesModal'
import { HeaderSubheader } from '../typography/HeaderSubheader'

export const ManageProductCategories = ({
  values,
  setFieldValue,
  errors,
  typeTitle,
}: {
  values: CreateProductValues
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean,
  ) => Promise<void> | Promise<FormikErrors<CreateProductValues>>
  errors?: string
  typeTitle: string
}) => {
  const { handleModalOpen, setModalOpen, modal, modalOpen, handleModalClose } =
    useModalControl()

  return (
    <div className="flex flex-col gap-6 pb-10 border-b border-divider-gray">
      <HeaderSubheader
        title={`${typeTitle} Categories`}
        text={`Specify ${typeTitle} categories`}
        className="w-full md:w-fit"
      />

      <EditInput
        title={`Categories`}
        value={undefined}
        onEditClick={() => {
          handleModalOpen('selectCategoriesModal')
        }}
        errors={errors}
        onCancel={() => {}}
        onEditSave={() => {}}
        editing={false}
        className={'col-span-full'}
      >
        {() => {
          return (
            <div className="flex flex-row gap-4 items-center flex-wrap">
              {values.category.map((category, idx) => {
                const key = `tag-${idx}`
                return <CategoryCard category={category} key={key} />
              })}
            </div>
          )
        }}
      </EditInput>

      <SelectCategoriesModal
        open={modalOpen && modal === 'selectCategoriesModal'}
        setOpen={setModalOpen}
        onCloseCallback={() => {
          handleModalClose()
        }}
        onSuccessCallback={(categories) => {
          setFieldValue('category', categories)
          handleModalClose()
        }}
        selectedCategories={values.category}
      />
    </div>
  )
}
